<template>
  <div class="">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "StepItemWrapper",
  async mounted() {
    await this.setForm()
  },
  methods: {
    // Recursive function to find a parent with a specific attribute
    findParentWithAttribute(parent, attributeName, attributeValue) {
      if (!parent) {
        // Reached the root component without finding the attribute
        return null;
      }

      if (parent.$el && parent.$el.getAttribute(attributeName) === attributeValue) {
        // Found the parent with the specified attribute
        return parent;
      } else {
        // Continue searching in the parent's parent
        return this.findParentWithAttribute(parent.$parent, attributeName, attributeValue);
      }
    },
    async setForm() {
      // Start the search for the parent with data-step-manager="true"
      const parentWithStepManager = this.findParentWithAttribute(this.$parent, 'data-step-manager-wrapper', 'true');

      if (parentWithStepManager) {
        // You found the parent with the specified attribute
        let stepManagerWrapperId = parentWithStepManager.$el.id

        let stepManagerState = await this.$store.dispatch('StepManager/getStepManagerForm', stepManagerWrapperId);
        this.$emit('stepManagerState', stepManagerState)

      } else {
        // No parent with the specified attribute found
        console.log('No parent with data-step-manager="true" found.');
      }
    }
  }
}
</script>

<style scoped>

</style>